module.exports = __webpack_public_path__ + "img/edificios.067601c8.jpeg";